import Vue from 'vue'
import ElementUI from 'element-ui'
import './assets/css/reset0.css'
import './assets/css/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/adder.less'

import BaiduMap from 'vue-baidu-map'
import App from './App.vue'

import './utils/pcrem.js'

// import Vconsole from 'vconsole';
// new Vconsole();



Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'b64gabe12QDrMF0R0n2AAdlK9YO2HCyo'
})

new Vue({
  render: h => h(App),
}).$mount('#app')
